import { AlertOutlined, CalendarOutlined, CheckCircleTwoTone, CustomerServiceOutlined, DollarOutlined, EyeFilled, FireFilled, FireOutlined, FlagOutlined, FlagTwoTone, GlobalOutlined, GoogleOutlined, PhoneOutlined, PlusCircleFilled, PlusCircleOutlined, QuestionCircleFilled, QuestionCircleOutlined, QuestionOutlined, RiseOutlined, SearchOutlined, SettingOutlined, ShopFilled, ShopOutlined, ShopTwoTone, WarningTwoTone } from "@ant-design/icons"
import { Badge, Button, Tooltip } from "antd"
import { STATUS } from "./OpenForBusiness"
import { HAS_VOICE_OF_MERCHANT, HAS_VOICE_OF_MERCHANT_COLOR } from "./VerifyStatus"
import { RegularDayScheduleViewSmall } from "./forms/RegularDayScheduleView"
import { FestiveScheduleSmall } from "../location/hours/single/FestiveScheduleView"
import moment from "moment"
import { useState } from "react"
import EditLocationVirtualGroupsModal from "../selectMonths/EditLocationVirtualGroupsModal"

export const Location = (props: {location: any, onChange?: any}) => {

	return (
		<div style={{background:'white', borderRadius:'10px', padding :'10px', display:'flex', justifyContent:'space-between'}}>
			<div style={{display:'flex'}}>
				{props.location.metadata && 
					<Tooltip title={HAS_VOICE_OF_MERCHANT[props.location.metadata.hasVoiceOfMerchant]}>					
						<Badge status={HAS_VOICE_OF_MERCHANT_COLOR[props.location.metadata.hasVoiceOfMerchant]}/>
					</Tooltip>
				}
				<div>
					<span style={{fontWeight: 600, fontSize: "15px", paddingRight:'10px'}}> {props.location.title}</span><br/>
					<AddressGroup record={props.location}/>					
					{ props.location?.openForBusiness?.status && props.location.openForBusiness?.status?.includes('CLOSED') && <div style = {{color:'crimson'}}>{STATUS[props.location.openForBusiness?.status]}</div>}					
					<LocationLabels location={props.location}/>
				</div>
			</div>
			
			{props.location.metadata?.mapsUri && <Button onClick={() => {props.onChange()}} size='small' style={{ borderRadius: '20px', background:'white',  border:`solid 1.3px RoyalBlue`, color: "RoyalBlue" }}>    
				<small><a target={'_blank'} href={props.location.metadata.mapsUri}><GoogleOutlined/> Ver en Google</a></small>
			</Button>}
		</div>		
	)
}

export const LocationCardCompacted = (props: {location: any, onChange?: any, onClick?: any, onClickDisabledReason?: string, warning?: boolean, color?:string, colorSettings?:string, label?:boolean}) => {

	let backgroundColor = props.color ? props.color : 'transparent';
	let colorSettings = props.colorSettings ? props.colorSettings : 'dodgerblue';
	let isLabel = props.label || false;

	const [openVirtualGroupsModal, setOpenVirtualGroupsModal] = useState<any>(null);

	const settingsIcon = props.warning ? (
		<Badge dot color='red'>
			<SettingOutlined style={{ color: props.onClickDisabledReason ? 'silver' : colorSettings }} />
		</Badge>
	) : (
		<SettingOutlined style={{ color: props.onClickDisabledReason ? 'silver' : colorSettings }} />
	);

	return (
		<>
			<div style={{
				background: backgroundColor,
				borderRadius: 10,
				minWidth: '200px',
				maxWidth: '340px',
				width: '100%',
				border: '1px solid rgba(148, 163, 184, 0.28)',
				padding: '10px 12px',
				boxSizing: 'border-box',
			}}>
				<div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap: 8}}>
					<div style={{ minWidth: 0, flex: 1, overflowWrap: 'anywhere', wordBreak: 'break-word' }}>					
						{props.location?.metadata?.mapsUri ?
						<a style={{ color: 'dodgerblue', textDecoration: 'none', marginRight: 4 }} target={'_blank'} rel="noopener noreferrer" href={props.location.metadata.mapsUri}><ShopOutlined/></a>
						:
						<ShopOutlined style={{ marginRight: 4, color: '#94a3b8' }}/>
						}
						<span style={{
							fontWeight: 600,
							fontSize: 13,
							color: '#0f172a',
							lineHeight: 1.3,
						}}>
							{props.location?.title}
						</span>
					</div>					
					<span style={{ flexShrink: 0 }}>
						{props.onClick && (
							props.onClickDisabledReason ? (
								<Tooltip
									color='transparent'
									overlayInnerStyle={{ padding: 0, boxShadow: 'none' }}
									title={
										<span style={{
											display: 'inline-block',
											padding: '10px 14px',
											borderRadius: 10,
											background: '#fffbeb',
											border: '1px solid #fcd34d',
											color: '#b45309',
											fontSize: 13,
											fontWeight: 500,
											lineHeight: 1.5,
											maxWidth: 280,
										}}>
											{props.onClickDisabledReason}
										</span>
									}
								>
									<span>
										<Button type="text" disabled size='small' style={{ borderRadius: '20px', cursor: 'not-allowed' }}>
											{settingsIcon}
										</Button>
									</span>
								</Tooltip>
							) : (
								<Button type="text" onClick={() => { props.onClick(); }} size='small' style={{ borderRadius: '20px' }}>
									{settingsIcon}
								</Button>
							)
						)}
					</span>
				</div>
				
				<LocationLabels location={props.location}/>
				<div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap: 8, marginTop: 4}}>
					<div style={{ minWidth: 0, flex: 1, overflowWrap: 'anywhere', wordBreak: 'break-word', fontSize: 11, color: '#94a3b8', lineHeight: 1.35 }}>
						{props.location && <> {props.location.addressLine ? 
							`${props.location?.addressLine} ${props.location.postalCode}, ${props.location?.locality}, ${props.location?.administrativeArea}`
							: 
							'Sin ubicación'}</>
						}
					</div>
					{isLabel &&
						<div style={{minWidth:'40px', display:'flex', justifyContent:'right', flexShrink: 0}}>					
							{ props.location.label ? 
								<div style={{cursor:'pointer'}} onClick={() => {setOpenVirtualGroupsModal(props.location)}}><Badge color={props.location.label}/></div>
								:
								<PlusCircleOutlined style={{color: 'silver'}} onClick={() => {setOpenVirtualGroupsModal(props.location)}}/>
							}
						</div>
					}
				</div>			
			</div>
			{openVirtualGroupsModal && <EditLocationVirtualGroupsModal location={openVirtualGroupsModal} onChange={() => {setOpenVirtualGroupsModal(null);}}/>}
		</>
	)	
}

export const LocationLabels = (props: {location: any}) => {

	return (
		<>
			{props.location?.openForBusiness?.status && 
				props.location.openForBusiness?.status?.includes('CLOSED') && 
				<div style={{
					color: 'crimson',
					background: '#ffe5e5', 
					padding: '1px 6px',
					borderRadius: '8px',
					display: 'inline-block',
					fontWeight: 500,
					fontSize: '13px',
					marginBottom: 4
				}}>
					{STATUS[props.location.openForBusiness?.status]}
				</div>
			}
			{/* !props.location?.metadata?.canOperateLocalPost && <WarningTwoTone twoToneColor="#eb2f96" /> */}
		</>
	)	
}

export const Place = (props: {place: any, onClick?: any}) => {

	let backgroundColor = 'transparent';

	return (
		<div style={{background: backgroundColor, borderRadius:'10px', minWidth: '250px', maxWidth:'300px', border:'1px solid lightgrey', padding :'10px'}}>
			<div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
				<span style={{fontWeight:400}}><FireOutlined style={{color: 'red'}}/> {props.place?.title}</span>				
				<span>
					{props.onClick && 
						<Button type="text" onClick={() => {props.onClick();}} size='small' style={{ borderRadius: '20px' }}>    										    	
							<SettingOutlined style={{color: 'dodgerblue'}}/> 							
						</Button>	
					}					
				</span>
			</div>
			<div>
				<small>
					{props.place && <> {props.place.address ? 
						<i style={{color:'grey'}}>{`${props.place?.address}`}</i>
						: 
						<i style={{color:'grey'}}>Sin ubicación</i>}</>
					}
				</small>
			</div>
			
		</div>
	)
}

export const LocationTitle = (props: {location: any}) => {

	return (
		<>
			<div>{props.location?.title}</div>
			<div>
				<small>
					{props.location && <> {props.location.addressLine ? 
						<i style={{color:'grey'}}>{`${props.location?.addressLine}, ${props.location?.locality}, ${props.location?.administrativeArea}`}</i>
						: 
						<i style={{color:'grey'}}>Sin ubicación</i>}</>
					}
				</small>
			</div>
        </>
	)
}

export const LocationDrawerHeader = (props: {location: any}) => {

	return (
		<div>
			<h2 style={{color:'LightSlateGray', margin: 0}}><b>{props.location?.title}</b></h2>
			{props.location && <> {props.location.addressLine ? 
				<i style={{color:'grey'}}>{`${props.location?.addressLine}, ${props.location?.locality}, ${props.location?.administrativeArea}`}</i>
				: 
				<i style={{color:'grey'}}>Sin ubicación</i>}</>
			}
		</div>
	)
}

export const Categories = (props: {categories: any}) => {

	return (		
		<div>
            <ul>
                <li>
                    <b style={{ color: "slategrey" }}>
                        {props.categories?.primaryCategory?.displayName}
                    </b>
                </li>
                {
                    props.categories?.additionalCategories && props.categories.additionalCategories?.map((additionalCategory: any, i: number) => (
                        <li style={{ color: "slategrey" }} key={i}>
                            {additionalCategory.displayName}
                        </li>
                    ))
                }
            </ul>
        </div>		
	)
}

export const NameGroup = (props: {record: any}) => {

	return (
		<>			
			<span style={{paddingRight:'10px'}}>{props.record.title}</span><br/>
			<small style={{color:'grey'}}>{props.record.categories?.primaryCategory?.displayName}</small>
		</>
	)
}

export const StatusGroup = (props: {record: any}) => {

	return (
		<p>
			{props.record.metadata.hasVoiceOfMerchant ?<CheckCircleTwoTone twoToneColor="#52c41a" /> : <WarningTwoTone twoToneColor="#eb2f96" />}<br/>
		</p>
	)
}

export const AddressGroup = (props: {record: any}) => {
	
	return (
	  (props.record.locality !== null && props.record.administrativeArea !== null) ? (
		<>
		  <span style={{ fontWeight: 600, fontSize: "12px", color:'#808080' }}>{props.record.locality},</span>
		  <i style={{ fontWeight: 600, fontSize: "12px", color:'#808080' }}> {props.record.administrativeArea}<br /></i>
		  {props.record.addressLine !== null && (
			<small style={{ color: '#808080', fontSize: "12px" }}>
			  {props.record.addressLine}
			</small>
		  )}
		</>
	  ) : (
		<small style={{ color: '#808080', fontSize: "12px" }}>Sin ubicación</small>
	  )
	);
  };
  
export const StoreCodeGroup = (props: {record: any}) => {

  	return (
		<>
			{
				props.record.storeCode ?
					props.record.storeCode : "-"
			}
			{
				props.record.todayPosts && 
					<CheckCircleTwoTone/>
			} 
		</>
	)
}

export const ContactGroup = (props: {record: any}) => {
		
		return (
			<>
				{props.record.websiteUri && <a><GlobalOutlined/> {props.record.websiteUri}<br/></a>}
				<span style={{marginRight:"1em"}}><PhoneOutlined/> {props.record.primaryPhone}</span>
				{ props.record.additionalPhones &&
				props.record.additionalPhones.map((additional:string, i:number)=>(
					<span style={{marginRight:"1em"}}><PhoneOutlined/> {additional}</span>
				))}
			</>
	  )
}

export const Hours = (props: {location: any}) => {
		
	return (
		<>
			<small>                        
				{props.location?.regularHours && <RegularDayScheduleViewSmall title="Lunes" regularHour={props.location?.regularHours![0]} />}
				{props.location?.regularHours && <RegularDayScheduleViewSmall title="Martes" regularHour={props.location?.regularHours![1]} />}
				{props.location?.regularHours && <RegularDayScheduleViewSmall title="Miércoles" regularHour={props.location?.regularHours![2]} />}
				{props.location?.regularHours && <RegularDayScheduleViewSmall title="Jueves" regularHour={props.location?.regularHours![3]} />}
				{props.location?.regularHours && <RegularDayScheduleViewSmall title="Viernes" regularHour={props.location?.regularHours![4]} />}
				{props.location?.regularHours && <RegularDayScheduleViewSmall title="Sábado" regularHour={props.location?.regularHours![5]} />}
				{props.location?.regularHours && <RegularDayScheduleViewSmall title="Domingo" regularHour={props.location?.regularHours![6]} />}				
			</small>  
		</>
  )
}

export const Festives = (props: {specialHours: any}) => {
		
	return (
		<>
			{props && props.specialHours && Object.entries(props.specialHours).map(([key, periods]) => (			
				<small style={{display:'flex', justifyContent:'space-between', alignItems:'center', color: "slategrey"}}>
					<div>                        					
						<CalendarOutlined/>	{moment(key).format('ll')}
					</div>  
					<div>   
						<FestiveScheduleSmall data={periods}/> 
					</div>  
				</small>  
			))}
		</>
  )
}

// *********************** WORKING ON ******************
